<template>
  <el-form ref="ruleForm" :rules="rules" :model="form" label-width="80px">
    <el-form-item prop="opinion" label="评审结果" :rules="[
      {
        required: true,
        trigger: 'blur',
      },
    ]">
      <el-radio-group v-model="form.opinion" @change="opinionChange">
        <el-radio border :label="2">审核通过</el-radio>
        <el-radio border v-if="alterEnable" :label="1">审核通过，需要改稿</el-radio>
        <el-radio border :label="3">不通过退稿</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item prop="remark" label="评审意见">
      <el-autocomplete type="textarea" :autosize="{ minRows: 3, maxRows: 10 }" class="inline-input" v-model="form.remark"
        :fetch-suggestions="remarkSuggestions" @select="remarkSelect" :placeholder="remarkHolder"
        :disabled="remarkDisabled" style="width:100%;"></el-autocomplete>
    </el-form-item>


    <el-form-item prop="file" v-show="form.opinion == 1" label="意见附件">
      <el-upload v-model="form.file" :action="uploadURL" :before-upload="uploadBefore" :multiple="false" name="file"
        list-type="text" :file-list="uploadFilelist" :limit="1" :headers="uploadHeaders" :on-exceed="uploadExceed"
        :on-success="uploadSuccess" :on-remove="uploadRemove"
        accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document">

        <el-button slot="trigger" size="small" type="default">修改意见docx附件…</el-button>
        <div slot="tip" class="el-upload__tip">只能上传docx文件，且不超过15MB</div>
      </el-upload>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" :disabled="!flag" :loading="btnLoading" @click="submit">提交</el-button>
      <el-button type="danger" v-if="rejectEnable" @click="reject">放弃评审，退回稿件池…</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import editorApi from "@/api/editor"
import expertApi from "@/api/expert"
import remarkApi from "@/api/remark"

import http from "@/api/http"
import { getToken } from "@/utils/auth"

export default {
  name: "FormExamine",
  props: {
    articleId: {
      type: Number,
      require: true,
    },
    articleTitle: {
      type: String,
      require: true,
    },
    role: {
      type: String,
      require: true,
    },
    //是否允许改稿
    alterEnable: {
      type: Boolean,
      require: true,
    },
    //是否允许回退稿件池
    rejectEnable: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      remarkDataValue: "",
      remarkData: [],
      form: {
        articleId: -1,
        attachId: -1,
        opinion: -1,
        remark: "",
      },
      remarkHolder: "请输入评审意见内容",
      remarkDisabled: true,
      flag: false,
      rules: {
        remark: [
          {
            required: true,
            min: 1,
            max: 500,
            message: "请输入评审意见内容（1~500字符）",
            trigger: "blur",
          },
        ],
      },

      uploadFilelist: [],
      uploadURL: "",
      uploadHeaders: { Authorization: getToken() },
      btnLoading:false,
    }
  },

  created() {
    this.uploadURL = http.defaults.baseURL + "attach/uploadPropose"
    this.loadOptions()
  },

  methods: {

    //https://huaweicloud.csdn.net/639feb62dacf622b8df90104.html?spm=1001.2101.3001.6650.3&utm_medium=distribute.pc_relevant.none-task-blog-2~default~CTRLIST~activity-3-126479947-blog-103408605.235^v27^pc_relevant_default&depth_1-utm_source=distribute.pc_relevant.none-task-blog-2~default~CTRLIST~activity-3-126479947-blog-103408605.235^v27^pc_relevant_default&utm_relevant_index=6

    loadOptions() {
      remarkApi.getAll().then((res) => {
        if (res.code == 0) {
          res.data.forEach((ele) => {
            this.remarkData.push({ id: ele.remarkId, value: ele.remarkContent })
          });
        }
      })
    },

    remarkSuggestions(queryString, cb) {
      if (queryString === '') {
        cb(this.remarkData);
      } else {
        cb(this.remarkData);
      }
    },

    remarkSelect(item) {
      if (item !== '') {
        this.$refs.ruleForm.validateField('remark');
      }
    },

    remarkDataChange(val) {
      this.form.remark = val
    },
    opinionChange(v) {
      if (v == 1) {
        this.remarkDisabled = false
        this.remarkHolder = "请输入评审意见"
        this.flag = true
        //this.$refs.formData2[0].validate(['remark']);
        //this.form.remark = this.form.remark == "" ? "论文很好，但是有部分内容需要需求，如下：\r\n1.\r\n2." : this.form.remark
      } else if (v == 2) {
        this.remarkDisabled = false
        this.remarkHolder = "请输入评审意见"
        this.flag = true
        //this.form.remark = this.form.remark == "" ? "同意" : this.form.remark
      } else if (v == 3) {
        this.remarkDisabled = false
        this.remarkHolder = "请输入退稿原由"
        this.flag = true
        //this.$refs.formData2[0].validate(['remark']);
      } else {
        this.flag = false
      }
      //this.$refs.formData2[0].resetFields();
    },

    //放弃评审
    reject() {
      this.$confirm("放弃评审“" + this.articleTitle + "”, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (this.role == "EDITOR") {
          editorApi.removeArticleFromCart(this.articleId).then((res) => {
            if (res.code == 0) {
              this.$notify({ title: "成功", message: "成功取消评审", type: "success" })
              this.getStat()
              this.$emit("examineReject")
            } else {
              this.$notify.error({ title: "错误", message: res.msg })
            }
          })
        } else if (this.role == "EXPERT") {
          expertApi.removeArticleFromCart(this.articleId).then((res) => {
            if (res.code == 0) {
              this.$notify({ title: "成功", message: "成功取消评审", type: "success" })
              this.getStat()
              this.$emit("examineReject")
            } else {
              this.$notify.error({ title: "错误", message: res.msg })
            }
          })
        }
      })
    },

    uploadExceed() {
      this.$alert("只能上传一个文件，请删除后再上传", "异常提示", {
        confirmButtonText: "确定",
        type: "warning",
      })
    },

    uploadBefore(file) {
      const isDOCX = file.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      const isLt5M = file.size / 1024 / 1024 < 15

      if (!isDOCX) {
        this.$alert("文件必须是扩展名为“DOCX”的文档", "系统提示", {
          confirmButtonText: "确定",
        })
      }
      if (!isLt5M) {
        this.$alert("文件不能超过 15MB!", "系统提示", {
          confirmButtonText: "确定",
        })
      }
      return isDOCX && isLt5M
    },

    uploadSuccess(res) {
      if (res.code == 1) {
        this.$alert("上传失败,请重新上传", "异常提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
        this.$refs.fileUpload.clearFiles()
      } else {
        this.form.attachId = res.data.attachId
        //this.form.attachCode = res.data.attachCode
        //this.$refs.formData.validateField("attachCode")
      }
    },

    uploadRemove() {

    },

    submit() {

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {

          this.$confirm("对“" + this.articleTitle + "”评审为"+(this.form.opinion==3?"不":'')+"通过, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: this.form.opinion==3?"warning":'success',
          }).then(()=>{
            this.btnLoading = true;
            this.submitFun();
          });
         
        }
      })
    },

    submitFun(){
      if (this.role == "EDITOR") {
            editorApi.doAudit(this.articleId, this.form.opinion, this.form.remark, this.form.attachId).then((res) => {
              this.btnLoading = false;
              if (res.code == 0) {
                this.$notify({
                  title: "成功",
                  message: "审稿成功",
                  type: "success",
                })
                this.getStat()
                this.$emit("examineSuccess")
              } else {
                this.$notify.error({
                  title: "错误",
                  message: res.msg,
                })
              }
            })
          } else if (this.role == "EXPERT") {
            expertApi.doAudit(this.articleId, this.form.opinion, this.form.remark, this.form.attachId).then((res) => {
              this.btnLoading = false;
              if (res.code == 0) {
                this.$notify({
                  title: "成功",
                  message: "审稿成功",
                  type: "success",
                })
                this.getStat()
                this.$emit("examineSuccess")
              } else {
                this.$notify.error({
                  title: "错误",
                  message: res.msg,
                })
              }
            })
          }
    },
  },
}
</script>

<style scoped>
.el-upload-list::v-deep .el-upload-list__item-name {
  color: #2d6ee8 !important;
  ;
}
.inline-input{
  font-size: 16px;
  font-family: '微软雅黑';
  font-family:MicrosoftYaHei;
}
</style>